import { styled } from 'goober';
import { Typography } from '@shared/ui/typography/typography';
import { COLORS } from '@shared/config/colors/colors';

export const Wrapper = styled('div')`
    display: flex;
    flex-direction: column;
    height: 100%;
    flex-grow: 1;
    justify-content: center;
    align-items: center;
`;

export const IconLargeWrapper = styled('div')`
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const IconSmallWrapper = styled('div')`
    display: flex;
    width: 72px;
    height: 72px;
    margin-bottom: 12px;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    background: ${COLORS.neutral_05};

    & * {
        color: ${COLORS.neutral_50};
        fill: ${COLORS.neutral_50};
        width: 40px;
        height: 40px;
    }
`;

export const Description = styled(Typography)`
    margin-top: 8px;
`;
